'use client';

import { c as _c } from "react/compiler-runtime";
import { useConstant } from '@cc-shopping/hooks/useConstant';
import { env } from '@cc-shopping/platform-env';
import { BrowserStorageWrapper } from '@cc-shopping/platform-storage';
import { AnalyticsBrowser, type AnalyticsBrowserSettings, type InitOptions } from '@segment/analytics-next';
import { createContext, type PropsWithChildren, useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { type SegmentAbstraction, SegmentLive, SegmentMock } from '../../lib/Segment';

/**
 * Analytics Context
 */
export interface AnalyticsContextValue {
  analytics: SegmentAbstraction;
  deployableName: string;
  deployableVersion: string;
  deviceId?: string;
  gitSha: string;
}
export const AnalyticsContext = createContext<AnalyticsContextValue | undefined>(undefined);

/**
 * Analytics Provider
 */

export interface AnalyticsProviderProps {
  deployableName: string;
  deployableVersion: string;
  writeKey: string;
  debug?: boolean;
}
export const AnalyticsProvider = t0 => {
  const $ = _c(14);
  const {
    deployableName,
    deployableVersion,
    writeKey,
    debug: t1,
    children
  } = t0;
  const debug = t1 === undefined ? false : t1;
  const [deviceId, setDeviceId] = useState();
  let t2;
  let t3;
  if ($[0] !== debug || $[1] !== writeKey) {
    t2 = () => {
      if (debug) {
        return new SegmentMock();
      }
      const settings = {
        writeKey,
        cdnURL: "https://siteusagetools.nerdwallet.com"
      };
      const options = {
        integrations: {
          "Segment.io": {
            apiHost: "siteusage.nerdwallet.com/v1",
            protocol: "https"
          }
        },
        storage: {
          stores: ["cookie", "localStorage", "memory"]
        }
      };
      const browserAnalytics = AnalyticsBrowser.load(settings, options);
      return new SegmentLive(browserAnalytics);
    };
    t3 = [writeKey, debug];
    $[0] = debug;
    $[1] = writeKey;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  const analytics = useConstant(t2, t3);
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const storage = new BrowserStorageWrapper();
      const cookies = new Map(document?.cookie.split("; ").map(_temp));
      if (cookies.has("cookie_id")) {
        setDeviceId(cookies.get("cookie_id"));
      } else {
        let storedCookieId = storage.getItem("cookie_id");
        if (!storedCookieId) {
          storedCookieId = uuid();
          storage.setItem("cookie_id", storedCookieId);
        }
        setDeviceId(storedCookieId);
      }
    };
    t5 = [];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== analytics || $[7] !== deployableName || $[8] !== deployableVersion || $[9] !== deviceId) {
    t6 = {
      analytics,
      deployableName,
      deployableVersion,
      deviceId,
      gitSha: env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA
    };
    $[6] = analytics;
    $[7] = deployableName;
    $[8] = deployableVersion;
    $[9] = deviceId;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== t6) {
    t7 = <AnalyticsContext.Provider value={t6}>{children}</AnalyticsContext.Provider>;
    $[11] = children;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
function _temp(cookieStr) {
  return cookieStr.split("=") as [string, string];
}